import { render } from "./ThongKeDieuTriTrucTuyen.vue?vue&type=template&id=0dbae1f0&scoped=true&ts=true"
import script from "./ThongKeDieuTriTrucTuyen.vue?vue&type=script&lang=ts"
export * from "./ThongKeDieuTriTrucTuyen.vue?vue&type=script&lang=ts"

import "./ThongKeDieuTriTrucTuyen.vue?vue&type=style&index=0&id=0dbae1f0&lang=scss&scoped=true"

import exportComponent from "/Volumes/DATA/Project/WebsiteProject/Dashboard_YHCT/Dashboard_FE_YHCT/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0dbae1f0"]])

export default __exports__